module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (104).6f1bbc8d.jpg";